import React, { Component } from 'react';
import { isEmpty } from '../../Common/common';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Select from '../../Part_Sample/Select';
import { navigateGroups } from '../../Common/navigation';

export default class Optional_Group_Display extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		this.group_info = JSON.parse(JSON.stringify(this.props.param.group_info));

		let temp_targ = '';
		let value_targ = '';

		if (this.group_info.temp_targ != null) temp_targ = this.group_info.temp_targ;
		if (this.group_info.value_targ != null) value_targ = this.group_info.value_targ;

		this.state = {
			temp_targ: temp_targ,
			value_targ: value_targ,
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Group_Edit', this.props.param);
	}

	handleChangeTempTarget = (point_id) => {
		this.setState({ temp_targ: point_id });
	}

	handleChangeValueTarget = (point_id) => {
		this.setState({ value_targ: point_id });
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		if (this.state.temp_targ == '') {
			if (this.group_info.temp_targ != null) delete this.group_info.temp_targ;
		} else {
			this.group_info.temp_targ = this.state.temp_targ;
		}

		if (this.state.value_targ == '') {
			if (this.group_info.value_targ != null) delete this.group_info.value_targ;
		} else {
			this.group_info.value_targ = this.state.value_targ;
		}

		if (this.props.param.group_id != null) {
			//edit screen
			this.props.receiver.modifyGroup([this.props.param.group_id, this.group_info]);
		} else {
			// add screen
			this.props.receiver.addGroup(this.group_info);
		}
	}

	rcvAddGroupResponse = (response) => {
		if (!isEmpty(response)) {
			this.moveToNextScreen();
		}
	}

	rcvModifyGroupResponse = (response) => {
		if (!isEmpty(response) && response.result == 'OK') {
			this.moveToNextScreen();
		}
	}

	moveToNextScreen = () => {
		if (this.props.param.from == 'Groups') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			navigateGroups("null");
		} else if (this.props.param.from == 'Group_Details') {
			this.props.content_handler('Group_Details', { group_info: this.group_info, group_id: this.props.param.group_id, from: this.props.param.group_detail_from })
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let temp_targ_selection = [];
		let value_targ_selection = [];

		temp_targ_selection.push(<option value={''} key={'temp-nil'}>{this.props.receiver.getString('none')}</option>)
		value_targ_selection.push(<option value={''} key={'val-nil'}>{this.props.receiver.getString('none')}</option>)

		for (let point_id of this.group_info.mp) {
			let point_info = window.app.state.point_list[point_id];
			if ((point_info.usage == 'ac') || (point_info.unit == 'DEG' && point_info.usage == 'temp')) {
				temp_targ_selection.push(<option value={point_id} key={'temp-' + point_id}>{point_info.name}</option>)
			} else if (point_info.type == 'Value' && point_info.usage != 'temp') {
				value_targ_selection.push(<option value={point_id} key={'val-' + point_id}>{point_info.name}</option>)
			} else if (point_info.type == 'Dehumi' && point_info.usage == 'dehumi') {
				value_targ_selection.push(<option value={point_id} key={'val-' + point_id}>{point_info.name}</option>)
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('optional_group_setting')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
						<span className='footnote' style={{ fontSize: 14 }}>{this.props.receiver.getString('optional_group_setting_instr')}</span>
					</div>
					<div style={{ marginTop: 10 }}>
						<div id='temp_target' style={{ marginLeft: 10, textAlign: 'left' }}>
							<div style={{ display: 'inline-block', width: this.props.width - 200, verticalAlign: 'top' }}>
								<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('temp')}</span>
							</div>
							<div style={{ display: 'inline-block', width: 180 }}>
								<Select
									style={{ display: 'inline-block' }}
									select_style={{ fontSize: 16, height: 35 }}
									options={temp_targ_selection}
									value={this.state.temp_targ}
									onSelect={this.handleChangeTempTarget}
								/>
							</div>
						</div>
					</div>
					<div style={{ marginTop: 20 }}>
						<div id='value_target' style={{ marginLeft: 10, textAlign: 'left' }}>
							<div style={{ display: 'inline-block', width: this.props.width - 200, verticalAlign: 'top' }}>
								<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('value_target')}</span>
							</div>
							<div style={{ display: 'inline-block', width: 180 }}>
								<Select
									style={{ display: 'inline-block' }}
									select_style={{ fontSize: 16, height: 35 }}
									options={value_targ_selection}
									value={this.state.value_targ}
									onSelect={this.handleChangeValueTarget}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}